/*
 * Accessibility fixes layered on top of theme.min.js (WCAG 2.2 AA).
 * Kept separate from the vendor bundle so theme updates don't overwrite it.
 */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var S = Object.assign({
    pause: 'Pause', play: 'Play',
    pauseSlideshow: 'Pause slideshow', playSlideshow: 'Play slideshow',
    pauseScrolling: 'Pause scrolling text', playScrolling: 'Play scrolling text',
    addedToBag: '__TITLE__ added to your bag', itemAdded: 'Item added to your bag',
    inStock: 'in stock', soldOut: 'sold out'
  }, window.a11yStrings || {});

  function announce(text) {
    var region = document.getElementById('a11y-announcer');
    if (!region) {
      region = document.createElement('div');
      region.id = 'a11y-announcer';
      region.className = 'visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      document.body.appendChild(region);
    }
    region.textContent = '';
    setTimeout(function () { region.textContent = text; }, 100);
  }

  // 2.2.2 Pause, Stop, Hide: every autoplaying carousel gets a pause button,
  // stops while it has keyboard focus, and never autoplays under reduced motion.
  function addPauseControl(el) {
    var swiper = el.swiper;
    if (!swiper || el.dataset.a11yPause || !swiper.params.autoplay || !swiper.params.autoplay.enabled) return;
    el.dataset.a11yPause = 'true';
    var userPaused = reduceMotion;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'a11y-pause';

    function render() {
      btn.setAttribute('aria-label', userPaused ? S.playSlideshow : S.pauseSlideshow);
      btn.innerHTML = userPaused
        ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 5h4v14H7zM13 5h4v14h-4z" fill="currentColor"/></svg>';
    }
    function apply() {
      swiper.params.autoplay.pauseOnMouseEnter = !userPaused;
      if (userPaused) swiper.autoplay.stop();
      else swiper.autoplay.start();
    }
    btn.addEventListener('click', function () {
      userPaused = !userPaused;
      render();
      apply();
    });
    el.addEventListener('focusin', function () { swiper.autoplay.stop(); });
    el.addEventListener('focusout', function (e) {
      if (!el.contains(e.relatedTarget) && !userPaused) swiper.autoplay.start();
    });

    render();
    apply();
    var host = el.closest('.announcement-bar') || el.parentElement;
    host.classList.add('a11y-pause-host');
    host.appendChild(btn);
  }

  function initCarousels() {
    document.querySelectorAll('.swiper, .swiper-container, [class*="carousel"]').forEach(addPauseControl);
  }

  // 2.2.2 for the scrolling marquee (CSS animation).
  function initMarquees() {
    document.querySelectorAll('scrolling-content').forEach(function (el) {
      if (el.dataset.a11yPause || reduceMotion) return;
      el.dataset.a11yPause = 'true';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'a11y-pause a11y-pause--marquee';
      var paused = false;
      function render() {
        btn.setAttribute('aria-label', paused ? S.playScrolling : S.pauseScrolling);
        btn.innerHTML = paused
          ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>'
          : '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 5h4v14H7zM13 5h4v14h-4z" fill="currentColor"/></svg>';
        el.classList.toggle('a11y-paused', paused);
      }
      btn.addEventListener('click', function () { paused = !paused; render(); });
      render();
      el.classList.add('a11y-pause-host');
      el.appendChild(btn);
    });
  }

  // 4.1.2: expose the selected swatch/chip; the theme only toggles a "selected" class.
  function syncPressed(btn) {
    btn.setAttribute('aria-pressed', btn.classList.contains('selected') ? 'true' : 'false');
  }
  var pressedObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) { syncPressed(m.target); });
  });
  function initOptionButtons(root) {
    root.querySelectorAll('[data-option-buttons] [data-button]').forEach(function (btn) {
      if (btn.dataset.a11yPressed) return;
      btn.dataset.a11yPressed = 'true';
      syncPressed(btn);
      pressedObserver.observe(btn, { attributes: true, attributeFilter: ['class'] });
    });
  }

  // 4.1.2: cart note toggle state lives on the hidden panel; mirror it on the button.
  var noteObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      var panel = m.target;
      var btn = document.querySelector('[aria-controls="' + panel.id + '"]');
      if (btn) btn.setAttribute('aria-expanded', panel.getAttribute('aria-hidden') === 'false' ? 'true' : 'false');
    });
  });
  function initCartNotes(root) {
    root.querySelectorAll('[cart-note-input][id]').forEach(function (panel) {
      if (panel.dataset.a11yNote) return;
      panel.dataset.a11yNote = 'true';
      noteObserver.observe(panel, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }

  // 4.1.2: dialogs filled in at runtime (quick view, generic modal) get a name from their heading.
  function labelDialogs(root) {
    root.querySelectorAll('[role="dialog"]').forEach(function (d) {
      if (d.hasAttribute('aria-labelledby') || (d.getAttribute('aria-label') || '').trim()) return;
      var h = d.querySelector('h1, h2, h3, .product__title, [class*="title"]');
      var text = h && h.textContent.trim();
      if (text) d.setAttribute('aria-label', text);
    });
  }

  // 1.3.1 / 2.4.6: templates whose title section is hidden still get a page heading.
  function ensureH1() {
    var main = document.getElementById('main') || document.querySelector('main');
    if (!main || document.querySelector('h1')) return;
    var h1 = document.createElement('h1');
    h1.className = 'visually-hidden';
    h1.textContent = window.a11yPageTitle || document.title.split(' – ')[0];
    main.insertBefore(h1, main.firstChild);
  }

  // 2.1.2 / 2.1.1: Escape closes the open drawer or popup. The theme's focus trap only
  // releases focus on Escape and leaves the drawer open.
  function isShown(el) {
    var s = getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' && el.getAttribute('aria-hidden') !== 'true';
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var active = document.activeElement;
    var dialog = active && active.closest && active.closest('[role="dialog"]');
    if (!dialog || !isShown(dialog)) {
      dialog = Array.prototype.filter.call(document.querySelectorAll('[role="dialog"]'), isShown).pop();
    }
    if (!dialog) return;
    var close = dialog.querySelector('[data-modal-close], [data-close-icon], [data-drawer-close], [data-popup-close], .drawer-menu__close, button[aria-label="Close"], button[aria-label="Close menu modal"]');
    if (close && isShown(close)) {
      close.click();
      returnFocus(dialog);
    }
  }, true);

  // 2.4.3: after a dialog closes, focus goes back to whatever opened it, not the page body.
  var lastOutsideFocus = null;
  document.addEventListener('focusin', function (e) {
    if (!e.target.closest('[role="dialog"]')) lastOutsideFocus = e.target;
  });
  function returnFocus(dialog) {
    var opener = lastOutsideFocus;
    setTimeout(function () {
      var a = document.activeElement;
      var lost = !a || a === document.body || a.matches('body *:not(a, button, input, select, textarea, [tabindex])') || dialog.contains(a);
      if (lost && opener && document.contains(opener)) opener.focus();
    }, 400);
  }
  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest && e.target.closest('[role="dialog"] [data-modal-close], [role="dialog"] [data-close-icon]');
    if (closeBtn && e.isTrusted) returnFocus(closeBtn.closest('[role="dialog"]'));
  });

  // 1.3.1: heading levels must not skip (e.g. h2 -> h6). Section settings and page content
  // pick tags for size, so normalise the levels screen readers hear without touching the visuals.
  function exposed(el) {
    return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden' && !el.closest('[aria-hidden="true"], [inert]');
  }
  function normaliseHeadings() {
    var prev = 0;
    document.querySelectorAll('h1, h2, h3, h4, h5, h6, [role="heading"]').forEach(function (h) {
      if (!exposed(h)) return;
      if (h.dataset.a11yLevel) h.removeAttribute('aria-level');
      var level = +(h.getAttribute('aria-level') || (h.tagName.match(/^H(\d)$/) || [0, 2])[1]);
      if (level === 1) { prev = 1; return; }
      var allowed = Math.max(prev, 1) + 1;
      if (level > allowed) {
        h.setAttribute('aria-level', allowed);
        h.dataset.a11yLevel = 'true';
        level = allowed;
      }
      prev = level;
    });
  }
  var headingTimer;
  function scheduleHeadings() {
    clearTimeout(headingTimer);
    headingTimer = setTimeout(normaliseHeadings, 300);
  }

  // Links used as buttons (role="button") must also respond to the space bar.
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if ((e.key === ' ' || e.key === 'Spacebar') && t.matches && t.matches('a[role="button"]')) {
      e.preventDefault();
      t.click();
    }
  });

  // 4.1.3 Status messages: price/stock after a variant change, and add-to-bag results.
  document.addEventListener('product:variant-change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v) return;
    var price = typeof v.price === 'number' && window.Shopify && Shopify.formatMoney
      ? Shopify.formatMoney(v.price)
      : (v.price / 100).toLocaleString(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
    var text = v.title + ', ' + price + ', ' + (v.available ? S.inStock : S.soldOut);
    var region = document.querySelector('[data-product-status]');
    if (region) region.textContent = text;
    else announce(text);
  });
  document.addEventListener('cart:item-added', function (e) {
    var p = e.detail && e.detail.product;
    announce(p && p.product_title ? S.addedToBag.replace('__TITLE__', p.product_title) : S.itemAdded);
  });
  document.addEventListener('cart:error', function (e) {
    var msg = e.detail && e.detail.errorMessage;
    if (msg) announce(msg);
  });

  // 2.4.3 / 2.4.7: the header-nav and thumbnail scroll arrows are mouse helpers that are often
  // invisible (opacity 0) yet focusable. Keyboard users reach every item with Tab and the strip
  // scrolls with focus, so keep the arrows out of the tab order and the accessibility tree.
  function hideScrollArrows(root) {
    root.querySelectorAll('[data-scroll-container] .scroll-button').forEach(function (btn) {
      btn.setAttribute('tabindex', '-1');
      btn.setAttribute('aria-hidden', 'true');
    });
  }

  // 4.1.2: the featured-collection switcher is marked up as tabs in Liquid; the theme only moves
  // a "selected" class, so mirror it into aria-selected/tabindex and add arrow-key movement.
  function syncTab(btn) {
    var on = btn.classList.contains('selected');
    btn.setAttribute('aria-selected', on ? 'true' : 'false');
    btn.tabIndex = on ? 0 : -1;
  }
  var tabObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) { syncTab(m.target); });
  });
  function initTabs(root) {
    root.querySelectorAll('[role="tablist"]').forEach(function (list) {
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      tabs.forEach(function (t) {
        syncTab(t);
        if (t.dataset.a11yTab) return;
        t.dataset.a11yTab = 'true';
        tabObserver.observe(t, { attributes: true, attributeFilter: ['class'] });
      });
      if (list.dataset.a11yTabs) return;
      list.dataset.a11yTabs = 'true';
      list.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(document.activeElement);
        if (i < 0) return;
        var next = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
        if (next === undefined) return;
        e.preventDefault();
        var t = tabs[(next + tabs.length) % tabs.length];
        t.focus();
        t.click();
      });
    });
  }

  // 4.1.2: an accordion block rendered twice (desktop and mobile columns) repeats its panel id,
  // so the second button controls the first panel. Give repeats their own id.
  function dedupeAccordionIds(root) {
    var seen = {};
    root.querySelectorAll('.accordion__content[id]').forEach(function (panel) {
      var id = panel.id;
      if (!seen[id]) { seen[id] = 1; return; }
      var unique = id + '-' + (++seen[id]);
      panel.id = unique;
      var btn = panel.closest('.accordion__inner') && panel.closest('.accordion__inner').querySelector('[aria-controls="' + id + '"]');
      if (btn) btn.setAttribute('aria-controls', unique);
    });
  }

  // Cart link names its item count, kept current when the theme updates the badge.
  function labelCart() {
    document.querySelectorAll('[data-js-cart-icon]').forEach(function (a) {
      var badge = a.querySelector('[data-js-cart-count]');
      var n = parseInt(badge && badge.textContent, 10) || 0;
      a.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
    });
  }

  function initAll(root) {
    initTabs(root);
    dedupeAccordionIds(root);
    labelCart();
    hideScrollArrows(root);
    initOptionButtons(root);
    initCartNotes(root);
    labelDialogs(root);
  }

  var dialogObserver = new MutationObserver(function () { labelDialogs(document); initOptionButtons(document); });

  // 1.4.3 / 2.4.7: the Smile "Pookie Club" widget uses white on light pink (about 1.5:1) for the
  // launcher, the panel header and the Join button, and pink on white for Sign in links.
  // Smile renders the launcher and panel in same-origin srcdoc iframes (a "lite" launcher first,
  // swapped for a full one after first use), so restyle them from here and keep watching,
  // because Smile rebuilds the frames.
  var LOYALTY_TEXT = '#22292D';
  var LOYALTY_FRAMES = '#smile-ui-lite-launcher-frame-container iframe, #smile-ui-container iframe';
  var LOYALTY_CSS = {
    launcher: 'button{color:' + LOYALTY_TEXT + ' !important}' +
      'button:focus-visible{outline:3px solid ' + LOYALTY_TEXT + ' !important;outline-offset:-6px}',
    panel: '.background-gradient,.background-gradient *,.btn-primary{color:' + LOYALTY_TEXT + ' !important}' +
      'a:not(.btn){color:' + LOYALTY_TEXT + ' !important;text-decoration:underline !important}' +
      'a:focus-visible,button:focus-visible{outline:3px solid ' + LOYALTY_TEXT + ' !important;outline-offset:2px}'
  };

  function fixLoyaltyFrame(frame) {
    var doc;
    try { doc = frame.contentDocument; } catch (e) { return; }
    if (!doc || !doc.body) return;
    if (!frame.dataset.psA11y) {
      frame.dataset.psA11y = '1';
      frame.addEventListener('load', function () { fixLoyaltyFrame(frame); });
    }
    if (!doc.getElementById('ps-a11y-loyalty')) {
      var style = doc.createElement('style');
      style.id = 'ps-a11y-loyalty';
      style.textContent = frame.classList.contains('smile-panel-frame') ? LOYALTY_CSS.panel : LOYALTY_CSS.launcher;
      (doc.head || doc.body).appendChild(style);
    }
    doc.querySelectorAll('img[src*="color=%23FFFFFF"]').forEach(function (img) {
      img.src = img.src.replace('color=%23FFFFFF', 'color=%2322292D');
    });
  }

  // 2.4.3: when the panel closes, Smile drops focus on the page body; send it back to the launcher.
  var loyaltyPanelOpen = false;
  function fixLoyaltyWidget() {
    document.querySelectorAll(LOYALTY_FRAMES).forEach(fixLoyaltyFrame);
    var open = !!document.querySelector('#smile-ui-container .smile-panel-frame');
    if (loyaltyPanelOpen && !open && (document.activeElement === document.body || !document.activeElement)) {
      var launcher = document.querySelector('#smile-ui-container .smile-launcher-frame, #smile-ui-lite-launcher-frame-container iframe');
      var btn;
      try { btn = launcher && launcher.contentDocument.querySelector('button'); } catch (e) {}
      if (btn) { launcher.focus(); btn.focus(); }
    }
    loyaltyPanelOpen = open;
  }

  function watchLoyaltyWidget() {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; fixLoyaltyWidget(); });
    }).observe(document.body, { childList: true, subtree: true });
    [0, 1500, 4000, 8000].forEach(function (ms) { setTimeout(fixLoyaltyWidget, ms); });
  }

  function moveSkipLink() {
    var skip = document.querySelector('.header__skip-to-content');
    if (skip && skip.parentElement !== document.body) document.body.insertBefore(skip, document.body.firstChild);
  }

  function start() {
    moveSkipLink();
    ensureH1();
    normaliseHeadings();
    initAll(document);
    initMarquees();
    watchLoyaltyWidget();
    // Swiper instances are created asynchronously by theme.min.js.
    [500, 1500, 3500].forEach(function (ms) { setTimeout(initCarousels, ms); });
    document.querySelectorAll('[data-quick-view-modal], [data-modal]').forEach(function (d) {
      dialogObserver.observe(d, { childList: true, subtree: true });
    });
    // Theme editor and section re-renders
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); initMarquees(); setTimeout(initCarousels, 500); });
    document.addEventListener('quickview:loaded', function () { initAll(document); scheduleHeadings(); });
    document.addEventListener('cart:updated', function () { initCartNotes(document); labelCart(); scheduleHeadings(); });
    document.querySelectorAll('[data-js-cart-count]').forEach(function (b) {
      new MutationObserver(labelCart).observe(b, { childList: true, characterData: true, subtree: true });
    });
    document.addEventListener('quick-cart:open', scheduleHeadings);
    window.addEventListener('load', scheduleHeadings);
    [1500, 4000].forEach(function (ms) { setTimeout(normaliseHeadings, ms); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
